import { EnvironmentValuesEnum, getApimPublicOcpKey } from '@fora-monorepo/fora-common';

declare global {
  interface Window {
    foraEnvironment: string;
    _mtm: { 'mtm.startTime': number; event: string }[];
  }
}

type EnvironmentConfig = {
  authApiBaseUri: string;
  bffBaseUri: string;
  apimSubscriptionKey: string;
  mockAuthFrontend: boolean;
  mockDataFrontend: boolean;
  azureTenantId: string;
  azureOrganizationClientId: string;
  devLogging?: boolean;
  matomoTagManagerUrl: string;
  applicationInsightsConnectionString: string;
  cookieDomain: string;
};

export const appName = 'webapp-employer-my-pages';

export const basePath = '/foretag';

const foraEnvironment = window.foraEnvironment === '%ENVIRONMENT%' ? 'local' : window.foraEnvironment;

export const envConfig: EnvironmentConfig = ((environment: string): EnvironmentConfig => {
  if (environment === 'dev') {
    return {
      authApiBaseUri: 'https://apim-dev.api.fora.se/api-auth',
      bffBaseUri: 'https://apim-dev.api.fora.se/bff-employer-my-pages/public',
      apimSubscriptionKey: getApimPublicOcpKey(EnvironmentValuesEnum.Development),
      mockAuthFrontend: false,
      mockDataFrontend: false,
      azureTenantId: 'c7a71c33-41de-4629-bb13-8c4bb50b547e',
      azureOrganizationClientId: '725c7d67-ca36-4aa3-bf6d-1f36710fc99d',
      devLogging: true,
      matomoTagManagerUrl: 'https://premium.analys.cloud/js/container_CmCkNFNS.js',
      applicationInsightsConnectionString:
        'InstrumentationKey=2d2f28ad-513f-48b3-ae03-3a74f991f4a2;IngestionEndpoint=https://westeurope-3.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/',
      cookieDomain: '.fora.se',
    };
  } else if (environment === 'qua') {
    return {
      authApiBaseUri: 'https://apim-qua.api.fora.se/api-auth',
      bffBaseUri: 'https://apim-qua.api.fora.se/bff-employer-my-pages/public',
      apimSubscriptionKey: getApimPublicOcpKey(EnvironmentValuesEnum.Quality),
      mockAuthFrontend: false,
      mockDataFrontend: false,
      azureTenantId: 'c7a71c33-41de-4629-bb13-8c4bb50b547e',
      azureOrganizationClientId: '725c7d67-ca36-4aa3-bf6d-1f36710fc99d',
      devLogging: true,
      matomoTagManagerUrl: 'https://premium.analys.cloud/js/container_CmCkNFNS.js',
      applicationInsightsConnectionString:
        'InstrumentationKey=651679c6-ee25-46e2-9cc9-19b830ac33b1;IngestionEndpoint=https://westeurope-4.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/',
      cookieDomain: '.fora.se',
    };
  } else if (environment === 'acc') {
    return {
      authApiBaseUri: 'https://apim-acc.api.fora.se/api-auth',
      bffBaseUri: 'https://apim-acc.api.fora.se/bff-employer-my-pages/public',
      apimSubscriptionKey: getApimPublicOcpKey(EnvironmentValuesEnum.Acceptance),
      mockAuthFrontend: false,
      mockDataFrontend: false,
      azureTenantId: 'c7a71c33-41de-4629-bb13-8c4bb50b547e',
      azureOrganizationClientId: '725c7d67-ca36-4aa3-bf6d-1f36710fc99d',
      matomoTagManagerUrl: 'https://premium.analys.cloud/js/container_CmCkNFNS.js',
      applicationInsightsConnectionString:
        'InstrumentationKey=b0ce2017-9fa7-4bef-a303-96794783c683;IngestionEndpoint=https://westeurope-3.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/',
      cookieDomain: '.fora.se',
    };
  } else if (environment === 'hpc') {
    return {
      authApiBaseUri: 'https://apim-hpc-r1.api.fora.se/api-auth',
      bffBaseUri: 'https://apim-hpc-r1.api.fora.se/bff-employer-my-pages/public',
      apimSubscriptionKey: getApimPublicOcpKey(EnvironmentValuesEnum.Hypercare),
      mockAuthFrontend: false,
      mockDataFrontend: false,
      azureTenantId: 'c7a71c33-41de-4629-bb13-8c4bb50b547e',
      azureOrganizationClientId: '725c7d67-ca36-4aa3-bf6d-1f36710fc99d',
      matomoTagManagerUrl: 'https://premium.analys.cloud/js/container_CmCkNFNS.js',
      applicationInsightsConnectionString:
        'InstrumentationKey=047eb081-21dd-4824-adc7-71b90aaf60e0;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/',
      cookieDomain: '.fora.se',
    };
  } else if (environment === 'prod') {
    return {
      authApiBaseUri: 'https://apim-pub.api.fora.se/api-auth',
      bffBaseUri: 'https://apim-pub.api.fora.se/bff-employer-my-pages/public',
      apimSubscriptionKey: getApimPublicOcpKey(EnvironmentValuesEnum.Production),
      mockAuthFrontend: false,
      mockDataFrontend: false,
      azureTenantId: 'c7a71c33-41de-4629-bb13-8c4bb50b547e',
      azureOrganizationClientId: '725c7d67-ca36-4aa3-bf6d-1f36710fc99d',
      matomoTagManagerUrl: 'https://premium.analys.cloud/js/container_rZiiIDtV.js',
      applicationInsightsConnectionString:
        'InstrumentationKey=7a92d325-41a9-4cc2-94c9-ab70b207be84;IngestionEndpoint=https://westeurope-3.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/',
      cookieDomain: '.fora.se',
    };
  }

  return {
    // Local env.
    authApiBaseUri:
      process.env.NX_PUBLIC_USE_LOCAL_AUTH === 'true'
        ? 'http://localhost:4021'
        : 'https://apim-dev.api.fora.se/api-auth',
    bffBaseUri:
      process.env.NX_PUBLIC_USE_LOCAL_BFF === 'true'
        ? 'http://localhost:4012/public'
        : 'https://apim-dev.api.fora.se/bff-employer-my-pages/public',
    apimSubscriptionKey: getApimPublicOcpKey(EnvironmentValuesEnum.Local),
    mockAuthFrontend: process.env.NX_PUBLIC_MOCK_AUTH_FRONTEND === 'true' || process.env.STORYBOOK === 'true',
    mockDataFrontend: process.env.NX_PUBLIC_MOCK_DATA_FRONTEND === 'true' || process.env.STORYBOOK === 'true',
    azureTenantId: 'c7a71c33-41de-4629-bb13-8c4bb50b547e',
    azureOrganizationClientId: '725c7d67-ca36-4aa3-bf6d-1f36710fc99d',
    devLogging: true,
    matomoTagManagerUrl:
      process.env.NX_PUBLIC_USE_MATOMO_TAG_MANAGER === 'true'
        ? 'https://premium.analys.cloud/js/container_CmCkNFNS.js'
        : '',
    applicationInsightsConnectionString:
      process.env.NX_PUBLIC_ENABLE_AI_TRACKING === 'true'
        ? 'InstrumentationKey=2d2f28ad-513f-48b3-ae03-3a74f991f4a2;IngestionEndpoint=https://westeurope-3.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/'
        : '',
    cookieDomain: 'localhost',
  };
})(foraEnvironment);
